import SignInContainer from '../../../../Containers/AdminContainer/Auth/SignIn';

const SignInScreen = () => {
  return <SignInContainer />;
};
export default SignInScreen;
